import { Injectable } from '@angular/core';
import md5 from 'md5';
import { ApiProvider } from '../api/api';
import { ListProvider } from '../list/list';
import { PopoverController, ModalController } from 'ionic-angular';
import { CoInterestedPopoverComponent } from '../../components/co-interested-popover/co-interested-popover';
import { CoEventEmailSharePage } from '../../pages/co-event-email-share/co-event-email-share';
import { CoSocialMediaButtonsPopoverComponent } from '../../components/co-social-media-buttons-popover/co-social-media-buttons-popover';
import { AppState } from '../../config/state';
import moment from 'moment';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
/*
  Generated class for the EventsProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class EventsProvider{
  private isSharedScreen: boolean;
  constructor(private api: ApiProvider, private state: AppState, private listProvider: ListProvider, private popoverCtrl: PopoverController, private modalCtrl: ModalController, public http: HttpClient) {
    this.isSharedScreen = this.state.sharedScreen;
  }
  getAgeGroups(){
    const queryAges = `{
      getEventAges {
        id, nameSingular, namePlural, color
      }
    }`;
    return this.api.getDataArray(queryAges, 'id');
  }
  getRegistrationAges(){
    const queryEventAges = `{
      getRegistrationAges{
        id, name, color
      }
    }`;
    return this.api.getDataArray(queryEventAges, 'id');
  }
  getEventTypes(){
    const queryTypes = `{
      getEventTypes {
        id, name, color, image
      }
    }`;
    return this.api.getDataArray(queryTypes, 'id').then( eventTypes => {
      this.state.eventColors = {
        ...this.state.eventColors,
        types: eventTypes
      }
      return eventTypes;
    });
  }

  async getBrochureFilters() {
    let ages = await this.getAgeGroups().then(ages=>ages.sort((a, b) => a.nameSingular.localeCompare(b.nameSingular)));
    ages.sort((a,b)=>{
      return (a.nameSingular.toUpperCase() < b.nameSingular.toUpperCase()) ? -1 : (a.nameSingular.toUpperCase() > b.nameSingular.toUpperCase()) ? 1 : 0;
    });
    let eventTypes = await this.getEventTypes().then(types=>types.sort((a, b) => a.name.localeCompare(b.name)));

    return { ages: ages, types: eventTypes};
  }

  async getEventAgesTypes() {
    let eventTypes = await this.getEventTypes().then(types=>types.sort((a, b) => a.name.localeCompare(b.name)));
    eventTypes.sort((a,b)=>{
      return (a.name.toUpperCase() > b.name.toUpperCase())
    });
    if (eventTypes) this.getDefaultEventImages(eventTypes);
    let ages = await this.getRegistrationAges().then(ages=>ages.sort((a, b) => a.name.localeCompare(b.name)));
    return { ages: ages, types:eventTypes };
  };

  async getEventRegistrants(eventId: number) {
    const queryEvents = `{
      getEventRegistrants(id:${eventId}){
        eventId, recurringId, registrationId, masterId, name, firstName, lastName, email, phone, age, libraryCard, registrationTime, status, totalGuests, checkedIn
      }
    }`;
    return this.api.query(queryEvents);
  }

  // ======================= FUNCTIONS FOR EVENT ATTENDANCE ==============================//

  async getEventAttendees(event):Promise<any>{
    // let info = new HttpParams();
    // // info = info.append('clientId', '157');
    // info = info.append('clientId', this.state.client.id);
    // // info = info.append('dateId', '23075');//REGISTERED EVENT
    // // info = info.append('dateId', '23074');// UNREGISTERED EVENT
    // info = info.append('deleted', '0');
    // info = info.append('dateId', event.eventId);
    // // let url = 'https://api-colin.communico.co/v2/detailedAttendance';
    // let url = 'https://api.communico.co/v2/detailedAttendance';
    // let registrants = await this.http.get(url, {params: info})
    // return registrants
    const queryAttendees = `{
        getEventAttendance(id: ${event.eventId}) {
          id, eventId, recurringId, registrationId, masterId, name, firstName, lastName, email, phone, age, libraryCard, checkinTime, totalGuests, checkedIn
        }
    }`;
    return this.api.query(queryAttendees);

  }

  async newAttendee(event, patron, ages):Promise<any>{
    let guests = patron.guests.map(g =>{
      let guest = {
        "firstName": g.firstName,
        "lastName": g.lastName,
        "checkedIn": "1",
        "deleted": "0",
        "email": g.email || "",
        "age_group": ages.find(a => {return a.id == g.ageGroup}).nameSingular
      }
      if (g.attendanceId) {
        guest['attendanceId'] = g.attendanceId;
        guest['update'] = "1"
      }
      if (g.parentId) guest['parentId'] = g.parentId;
      if (g.deleted) guest['deleted'] = "1";
      return guest;
    });
    let attendee = {
      // "clientId": 157,
      "clientId": this.state.client.id,
      // "dateId": 21902,
      // "dateId": 23074,
      "dateId": event.eventId,
      "draftId": event.recurringId,
      "firstName": patron.firstName,
      "lastName": patron.lastName,
      "email": patron.email || "",
      "phone": patron.phone || "",
      "librarycard": patron.barcode,
      "scanTime": moment().format("YYYY-MM-DD hh:mm:ss"),
      "age_group": ages.find(a => {return a.id == patron.ageGroup}).nameSingular,
      "update": "0",
      "checkedIn": "1",
      // "isGuest":"0",
      "guests": JSON.stringify(guests),
    };
    if (patron.attendanceId){
      attendee['attendanceId'] = patron.attendanceId;
      attendee['update'] = '1';
    }
    if (patron.deleted) {
      attendee['deleted'] = '1';
      attendee['checkedIn'] = '0';
    }
    // if (patron.isGuest){
    //   attendee['isGuest'] = '1';
    //   attendee['parentId'] = patron.parentId;
    // }
    if (patron.registrationId) {
      attendee['registrationId'] = patron.registrationId;
      attendee['update'] = '1';
    }
    // console.log(attendee);
    return fetch('https://api.communico.co/v2/checkin', {
    // return fetch('https://api-colin.communico.co/v2/checkin', {
      method: 'post',
      body: JSON.stringify(attendee),
      headers: {'Content-Type': 'application/json'}
    }).then(res => res.json()).then(result =>{
      return result
    }).catch(err => {return false});
  }

  async togglePatronAttendance(event, patron):Promise<any>{
    // let attendee = {
    //   "registrationId": patron.registrationId,
    //   // "clientId": 157,
    //   "clientId": this.state.client.id,
    //   // "dateId": 21902,
    //   // "dateId": 23075,
    //   "dateId": event.eventId,
    //   "draftId": event.recurringId,
    //   // "draftId": 55427,
    //   "scanTime": moment().format("YYYY-MM-DD hh:mm:ss"),
    //   "update": "1",
    //   // "checkedIn": "1",
    //   "checkedIn": patron.checked? 1 : 0,
    //   "attendanceId": patron.attendanceId,
    //   // "parentId": null,
    //   "parentId": patron.parentId || null,
    //   "isGuest": patron.isGuest,
    //   // "isGuest": 0,
    // };
    // if (patron.attendanceId) attendee['attendanceId'] = patron.attendanceId;
    return fetch(`https://api.communico.co/v2/checkin/${patron.registrationId}/${patron.checkedIn?1 : 0}`).then(res => res.json()).then(result =>{
      return result
    }).catch(err => {return false});
  }

  async getEvents(queryArgs: string) {
    let events: any = {};
    let eventsSearchTypes: any;
    if (events && events.length > 0) {
      // return events
    };
    // query arguments: start, limit, locationId, roomId, privateEvents, branchFeatured, globalFeatured, status, startDate, endDate, term, ages, types, searchTags

    const queryEvents = `{
      allEvents(${queryArgs}, limit:3000, status:"published", showUnpublishedEvents: true){
        ages,types,modifiedType,title,status,roomId,eventId,subTitle,allowGuests,allowReg,thirdPartyReg,regURL,eventEnd,roomName,setupTime,locationId,searchTags,isModified,eventStart,newEventId,eventImage,recurringId,description,contactName,maxAttendees,locationName,totalWaitlist,inPersonWaitlistLeft,virtualWaitlistLeft,allowWaitlist,breakdownTime,isPrivateEvent,customQuestions{ title helpText link required validate regex type name options},totalRegistrants,shortDescription,reportingCategory,registrationOpens,registrationCloses,globalFeatured,branchFeatured,ticketed,totalAttendance,eventType,inPersonSeatsLeft,virtualSeatsLeft
      }
    }`; //TODO: REMOVE THE LIMIT

    events.allEvents = await this.api.getDataArray(queryEvents, 'eventId', null, 880, md5(queryArgs));

    events.allEvents =  await events.allEvents.filter(event => {
      return !event.isPrivateEvent;
    });

    let eventTypes = await this.getEventAgesTypes()
    events.searchTypes = eventTypes.types;

    events = await this.checkInterestedEvents(events);
    events.allEvents.sort((a,b)=>{
      return moment(a.eventStart).diff(b.eventStart)
    })
    return events;
  };

  async getEventsNoCache(queryArgs: string) {
    let events: any = {};
    let eventsSearchTypes: any;

    const queryEvents = `{
      allEvents(${queryArgs}, limit:3000, status:"published", showUnpublishedEvents: true){
        ages,types,title,status,roomId,eventId,subTitle,allowReg,thirdPartyReg,regURL,eventEnd,roomName,setupTime,locationId,searchTags,isModified,eventStart,newEventId,eventImage,recurringId,description,contactName,maxAttendees,locationName,totalWaitlist,inPersonWaitlistLeft,virtualWaitlistLeft,allowWaitlist,breakdownTime,isPrivateEvent,customQuestions{ title helpText link required validate regex type name options},totalRegistrants,shortDescription,reportingCategory,registrationOpens,registrationCloses,globalFeatured,branchFeatured,ticketed,totalAttendance
      }
    }`; //TODO: REMOVE THE LIMIT

    events = await this.api.query(queryEvents);

    let eventTypes = await this.getEventAgesTypes()
    events.searchTypes = eventTypes.types;

    events = await this.checkInterestedEvents(events);
    events.allEvents.sort((a,b)=>{
      return moment(a.eventStart).diff(b.eventStart)
    })
    return events;
  };

  async getEventByTicket(ticketBarcode: string) {
    let event: any = false;
    if (event && event.length > 0) {
      // return events
    };
    // query arguments: start, limit, locationId, roomId, privateEvents, branchFeatured, globalFeatured, status, startDate, endDate, term, ages, types, searchTags

    const queryEvents = `{
      getEventByTicket(barcode: ${ticketBarcode}){
        eventId,recurringId,registrationId,name,email,phone,age,libraryCard,registrationTime,status,guests,customQuestions{title answer}
      }
    }`;
    event = await this.api.query(queryEvents);

    //check event for being in interested list
    await this.listProvider.getList('events').then((res) => {
      res.forEach(eventInList => {
        if (event.interested === undefined) {
          event.interested = false;
        }

        if (eventInList.value.eventId === event.eventId) {
          event.interested = true;
        }
      });
    });

    return event.getEventByTicket;
  };

  async getSingleEvent(eventId) {
    let eventDetails: any = {};
    let details: any;
    let eventTypes: any;

    const query = `{
      getEvent(id:${eventId}){
        ages,types,modifiedType,title,status,roomId,eventId,subTitle,allowGuests,allowReg,thirdPartyReg,regURL,eventEnd,roomName,setupTime,locationId,searchTags,isModified,eventStart,newEventId,eventImage,recurringId,description,contactName,maxAttendees,locationName,totalWaitlist,inPersonWaitlistLeft,virtualWaitlistLeft,allowWaitlist,breakdownTime,isPrivateEvent,customQuestions{ title helpText link required validate regex type name options},totalRegistrants,shortDescription,reportingCategory,registrationOpens,registrationCloses
      }
    }`;
    details = await this.api.getData(query, 'eventId', eventId);
    eventDetails.eventDetails = details;
    eventTypes = await this.getEventAgesTypes();
    eventDetails.types = eventTypes.getEventTypes;
    eventDetails.eventDetails = await this.checkInterestedEvents(eventDetails.eventDetails);
    return eventDetails;
  }

  // getDistance(currentPos, locationInfo) {
  //   var radlat1 = Math.PI * currentPos.lat / 180;
  //   var radlat2 = Math.PI * locationInfo.lat / 180;
  //   var theta = currentPos.lng - locationInfo.lng;
  //   var radtheta = Math.PI * theta / 180;
  //   var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
  //   dist = Math.acos(dist);
  //   dist = dist * 180 / Math.PI;
  //   dist = dist * 60 * 1.1515;
  //   return dist.toFixed(1);
  // }

  async registerForEvent(registerObj: any, bookingSource: string) {
    let params = { 
      input: registerObj,
      bookingSource
    };

    let registerQuery = `
      mutation reservation($input: registrantInputType!, $bookingSource: BookingSourceEnum!) {
        registerForEvent(input: $input, bookingSource: $bookingSource) {
          reference
          ok
          message
        }
      }
    `

    let response = await this.api.query(registerQuery, params);
    if (response && response.registerForEvent) {
      return response.registerForEvent;
    }
    return false;
  }


  async checkInterestedEvents(events) {
    if(!events) {
      console.log("events is undefined or null, can't check interested events");
      return;
    }
    if (!events.allEvents) {
      await this.listProvider.getList('events').then((res) => {
        if (res.length === 0) {
          if (events.interested === undefined) {
            events.interested = false;
          }
          events.interested = false;
        } else {
          let setToFalse = true;
          res.forEach((eventInList) => {
            if (events.interested === undefined) {
              events.interested = false;
            }
            if (eventInList.value.eventId === events.eventId) {
              events.interested = true;
              setToFalse = false;
              return;
            }
          });
          if (setToFalse) {
            events.interested = false;
          }
        }
      });
    } else {
      await this.listProvider.getList('events').then((res) => {
        if (res.length === 0) {
          events.allEvents.forEach(event => {
            if (event.interested === undefined) {
              event.interested = false;
            } else {
              event.interested = false;
            }
          });
        } else {
          events.allEvents.forEach(event => {
            let setToFalse = true;
            res.forEach(eventInList => {
              if (event.interested === undefined) {
                event.interested = false;
              }
              if (eventInList.value.eventId === event.eventId) {
                event.interested = true;
                setToFalse = false;
                return;
              }
            });
            if (setToFalse) {
              event.interested = false;
            }
          });
        }
      });
    }
    return events;
  }

  openInterestedPopover(button, event, card) {
    this.isSharedScreen = this.state.sharedScreen;
    if (this.isSharedScreen || this.state.staff) {
      let modal = this.modalCtrl.create(CoEventEmailSharePage, { event: event }, {cssClass: "interested-shared-modal", enableBackdropDismiss: false});
      modal.present();
    } else {
      let customClass = 'custom-popover-interested-button';
      let popover = this.popoverCtrl.create(CoInterestedPopoverComponent, { event: event, previousCard: card }, { cssClass: customClass });
      popover.present({
        ev: button
      });
    }
  }

  openSocialMediaPopover(button, event) {
    let cssClass = 'custom-social-media-share'
    let popover = this.popoverCtrl.create(CoSocialMediaButtonsPopoverComponent, { event: event }, { cssClass: cssClass } );
    popover.present({
      ev: button
    });
  }

  getDefaultEventImages(eventTypes): Promise<Array<any>>{
    let pgIconsById = {229:'am-profile', 230:'am-themes', 233:'am-book-format', 272:'am-branches', 235:'fa fa-laptop', 319:'fa fa-language', 238:'am-motion-picture-format', 350:'fa fa-heartbeat', 242:'am-videogame-format', 244:'fa fa-cogs', 273:'am-profile', 320:'am-content', 250:'fa fa-cogs', 251:'fa fa-star', 252:'am-book-format', 254:'am-users', 256:'fa fa-pencil-square-o', 257:'am-book-format', 351:'am-users', 901:'am-users', 1106:'fa fa-heart'}
    // let starkIconsById = {41:'am-themes', 26:'am-book-format',29:'am-book-format',46:'am-book-format',43:'am-profile',37:'am-motion-picture-format',44:'am-users',28:'am-themes',38:'am-content',42:'am-book-format',24:'fa fa-cogs',25:'am-profile',45:'am-users'};
    eventTypes.map(e => {
      e.icon = pgIconsById[e.id]
    });
    return eventTypes
  }
  createTicket(queryArgs: string) {
    let ticketQuery = `
      mutation createTicket {
        creatTicket(input: { ${queryArgs} })
      }
    `;

    return this.api.query(ticketQuery);
  }

}

export interface coEventsParameters {
  ages?: Array<string>;
  types?: Array<string>;
  title?: string;
  status?: string;
  roomId?: number;
  eventId?: number;
  subTitle?: string;
  allowReg?: boolean;
  eventEnd?: string;
  roomName?: string;
  setupTime?: string;
  locationId?: number;
  searchTags?: any;
  isModified?: boolean;
  eventStart?: string;
  newEventId?: number;
  eventImage?: any;
  recurringId?: number;
  description?: string;
  contactName?: string;
  maxAttendees?: number;
  locationName?: string;
  totalWaitlist?: number;
  inPersonWaitlistLeft?: number;
  virtualWaitlistLeft?: number;
  allowGuests?: boolean;
  allowWaitlist?: boolean;
  breakdownTime?: string;
  isPrivateEvent?: boolean;
  customQuestions?: Array<string>;
  totalRegistrants?: number;
  shortDescription?: string;
  reportingCategory?: any;
  registrationOpens?: string;
  registrationCloses?: string;
}

export interface coEventTypes {
  name?: string;
  color?: string;
}

export interface coEventRegistrant {
  eventId: number;
  recurringId: number;
  registrationId: number;
  name: string;
  email?: string;
  phone?: string;
  age?: number;
  libraryCard?: string;
  registrationTime: string;
  status: number;
  guests?: number;
  customQuestions?: any;
  patronBarcode?: string;
  patronCheckedIn?: boolean;
}


// WEBPACK FOOTER //
// ./src/providers/events/events.ts